<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>

    <vs-row v-if="boletos.length > 0">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card>
          <vs-collapse type="border">
            <vs-collapse-item v-for="item in boletos" :key="item.nosso_numero">
              <div slot="header">
                <vs-chip
                  class="mr-4"
                  :color="getPlacaColor(dados.dadosVeiculo.placa)"
                  >{{ dados.dadosVeiculo.placa }}</vs-chip
                >
                <vs-chip class="mr-4" :color="getStatusBoletoColor(item)">{{
                  item.situacao_boleto
                }}</vs-chip>
                <vs-chip v-if="validaVencido(item)" class="mr-4" color="danger"
                  >Vencido</vs-chip
                >
                {{ formataDataUTCAux(item.data_vencimento) }} -
                {{ item.tipo_boleto }}
              </div>
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-w="12"
                  vs-sm="12"
                  vs-xs="12"
                >
                  <table class="table tabela table-bordered">
                    <tr v-if="item.nome_associado">
                      <th class="uppercase">Associado</th>
                      <td>{{ item.nome_associado }}</td>
                    </tr>
                    <tr v-if="item.nosso_numero">
                      <th class="uppercase">Nosso Número</th>
                      <td>{{ item.nosso_numero }}</td>
                    </tr>
                    <tr>
                      <th class="uppercase">Data de Emissão</th>
                      <td>
                        {{ formataDataUTCAux(item.data_emissao) }}
                      </td>
                    </tr>
                    <tr>
                      <th class="uppercase">Data de Vencimento</th>
                      <td>
                        {{ formataDataUTCAux(item.data_vencimento) }}
                      </td>
                    </tr>
                    <tr v-if="item.data_pagamento">
                      <th class="uppercase">Data de Pagamento</th>
                      <td>
                        {{ formataDataUTCAux(item.data_pagamento) }}
                      </td>
                    </tr>
                    <tr>
                      <th class="uppercase">Valor</th>
                      <td>{{ item.valor_boleto | currency }}</td>
                    </tr>
                    <tr>
                      <th class="uppercase">Valor Pago</th>
                      <td>{{ item.valor_pagamento | currency }}</td>
                    </tr>
                    <tr v-if="item.linha_digitavel">
                      <th class="uppercase">Linha Digitavel</th>
                      <td>{{ item.linha_digitavel }}</td>
                    </tr>
                    <tr v-if="item.linkBoleto">
                      <th class="uppercase">Link Boleto</th>
                      <td item.linkBoleto></td>
                    </tr>
                    <tr v-if="item.pixImage">
                      <th class="uppercase">Pix Qr Imagem</th>
                      <td><img :src="item.pixImage" /></td>
                    </tr>
                    <tr v-if="item.pixQrCode">
                      <th class="uppercase">Pix Qr Code</th>
                      <td>{{ item.pixQrCode }}</td>
                    </tr>
                  </table>
                </vs-col>
              </vs-row>

              <vs-row
                justify="space-between"
                class="row-flex justify-content-between"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="space-between"
                  vs-w="12"
                  vs-sm="12"
                  vs-xs="12"
                >
                  <table
                    class="table tabela2 table-bordered"
                    style="width: 100%"
                  >
                    <tr>
                      <th class="uppercase">Veiculo</th>
                      <th class="uppercase">Placa</th>
                    </tr>

                    <tr>
                      <td>
                        {{ modelo }}
                      </td>
                      <td>
                        {{ placa }}
                      </td>
                    </tr>
                  </table>
                </vs-col>
              </vs-row>
            </vs-collapse-item>
          </vs-collapse>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-row v-if="naoTemBoleto">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card>
          <div><h4>Não há boletos em aberto</h4></div>
        </vs-card>
      </vs-col>
    </vs-row>

    <!--vs-tabs v-model="passo">
        <vs-tab label="Dados Gerais"> </vs-tab>
        <vs-tab label="Dados de Remessa"> </vs-tab>
        <vs-tab label="Dados do Beneficiário"> </vs-tab>
        <vs-tab label="Dados do Nosso Número"> </vs-tab>
        <vs-tab label="Dados do Boleto"> </vs-tab>
      </vs-tabs-->
  </div>
</template>

<script>
import locale from '../../locale';
import Table from '../../ui-elements/table/Table.vue';
import service from '../../services';
import jwt from 'jsonwebtoken';
import moment from 'moment';

export default {
  props: {
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.buscaBoletos();
    },
  },
  data() {
    return {
      boletos: [],
      nossoNumero: '',
      placa: '',
      modelo: '',
      naoTemBoleto: false,
    };
  },
  methods: {
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    buscaBoletos() {
      this.$vs.loading();

      var objSend = {};
      objSend.idProspect = this.dados.dadosCliente.idProspect;
      objSend.idEmpresa = this.dados.idEmpresa;
      objSend.cpfcnpj = this.dados.dadosCliente.cpf;
      objSend.placa = this.dados.dadosVeiculo.placa;
      objSend.chassi = this.dados.dadosVeiculo.chassi;

      service
        .post('Boletos', 'detalhesFinanceiros', objSend)
        .then(async (res) => {
          res.data.forEach((element) => {
            if (Array.isArray(element.veiculos)) {
              element.veiculos.forEach((elementAux) => {
                this.placa = elementAux.placa;
                this.modelo = elementAux.modelo;
              });
            }
          });

          var arrAux = res.data;
          for (let index = 0; index < arrAux.length; index++) {
            var element = arrAux[index];
            element.linkBoleto = '';

            // element.valor_pagamento.replace(',', '.');
            {
              if (element.link_boleto) {
                element.linkBoleto = element.link_boleto;
              }
            }
          }

          this.boletos = arrAux.filter((x) => x.situacao_boleto != 'EXCLUIDO');

          // this.boletos.valor_pagamento.replace(',', '.');
          // if (this.boletos.length > 0)
          if (this.boletos.length == 0) {
            this.naoTemBoleto = true;
          }

          setTimeout(() => {
            this.$vs.loading.close();
          }, 2000);

          // this.carregando = false;
        })
        .catch(() => {
          this.naoTemBoleto = true;

          this.$vs.loading.close();
          // this.carregando = false;
          this.erroConexao =
            'Seu aplicativo parece estar offline, verifique sua conexao';
        });
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    getStatusBoletoColor(boleto) {
      if (boleto.situacao_boleto.toUpperCase() === 'FINALIZADO')
        return 'success';
      if (boleto.situacao_boleto.toUpperCase() === 'EM ABERTO')
        return 'warning';
      if (boleto.situacao_boleto.toUpperCase() === 'ABERTO') return 'warning';
      if (boleto.situacao_boleto.toUpperCase() === 'BAIXADO COM PENDÊNCIA')
        return 'warning';
      if (boleto.situacao_boleto.toUpperCase() === 'EM PROCESSAMENTO')
        return 'primary';
      if (boleto.situacao_boleto.toUpperCase() === 'PROCESSADO COM FALHA')
        return 'danger';
      if (boleto.situacao_boleto.toUpperCase() === 'CANCELADO') return 'danger';
      if (boleto.situacao_boleto.toUpperCase() === 'NÃO PROCESSADO')
        return 'dark';
    },
    verificaVencimento(boleto) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + '-' + mm + '-' + dd;

      if (boleto.data_vencimento < today) {
        return 'danger';
      }
    },
    getPlacaColor(data) {
      if (data) return 'dark';
    },
    validaVencido(item) {
      if (
        item.situacao_boleto.toUpperCase() != 'FINALIZADO' &&
        item.situacao_boleto.toUpperCase() != 'CANCELADO'
      ) {
        if (moment().diff(moment(item.data_vencimento), 'days') > 0)
          return true;
      }
      return false;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.getDecoded();
  },
  components: {},
};
Table;
</script>
<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

.tabela {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid black;
}
.con-vs-popup .vs-popup {
  width: 870px;
}
.tabela2 {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important ;
}
li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>
<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}
</style>
